// extracted by mini-css-extract-plugin
export default {"wrap":"HomeBanners_wrap__R1Idh","fullBanner":"HomeBanners_fullBanner__ip9J0"};